// Mutations do módulo Gestão Fee Fixo.
// Apenas as classes de API (via actions) commitam aqui.

import { salvarCodigoClienteAtivo } from '@modules/fee-fixo/utils/clienteAtivoStorage'

// Grava data + timestamp de um slice { data, loading, lastUpdate }. Aceita
// array ou objeto vazio (typeof [] === 'object') — resultado vazio também
// atualiza o lastUpdate, então fica cacheado (não refaz request à toa).
const setData = (slice, payload) => {
  if (payload && typeof payload === 'object') {
    slice.data = payload
    slice.lastUpdate = new Date()
  }
}

// --- Dashboard ---
export const SET_DASHBOARD = (state, payload) =>
  setData(state.dashboard, payload)
export const SET_DASHBOARD_LOADING = (state, payload) => {
  state.dashboard.loading = !!payload
}

// --- Clientes (por visão) ---
export const SET_CLIENTES_PROFISSIONAL = (state, payload) =>
  setData(state.clientesProfissional, payload)
export const SET_CLIENTES_PROFISSIONAL_LOADING = (state, payload) => {
  state.clientesProfissional.loading = !!payload
}
export const SET_CLIENTES_ESCRITORIO = (state, payload) =>
  setData(state.clientesEscritorio, payload)
export const SET_CLIENTES_ESCRITORIO_LOADING = (state, payload) => {
  state.clientesEscritorio.loading = !!payload
}
// Visão ativa do toggle (só o seletor troca).
export const SET_CLIENTES_VISAO = (state, visao) => {
  state.clientesVisao = visao || 'profissional'
}

// --- Simulação (histórico de análises) ---
export const SET_ANALISES = (state, payload) => setData(state.analises, payload)
export const ADD_ANALISE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = structuredClone(payload)
    if (!Array.isArray(dados)) dados = [dados]
    dados.forEach((data) => {
      const old = state.analises.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.analises.data.push(data)
      }
    })
  }
}
export const SET_ANALISES_LOADING = (state, payload) => {
  state.analises.loading = !!payload
}

// Mapeia campos do patch (camelCase, contrato da action) para os campos do
// item na tabela de Clientes (snake_case, contrato do backend).
const CAMPO_PATCH_MAP = {
  etapaNome: 'etapa_nome',
  etapaCor: 'etapa_cor',
  desfecho: 'desfecho',
  statusMigracao: 'status_migracao',
}

// Patch otimista de status (etapa/desfecho) de UM cliente, nos dois slices da
// tabela de Clientes. Casa por codigo_cliente (string) e, quando ausente
// (payload do Kanban não carrega codigo_cliente — D-EX1), por id_cliente_app
// (numérico). Não encontrado em um slice → aquele slice não é tocado (no-op
// silencioso, ex.: tabela ainda não carregada em memória).
//
// Aplica SÓ os campos presentes em `patch` (!== undefined) — review PR #1793
// MUST-DO #1: um payload parcial (ex.: só etapaNome) não deve zerar
// status_migracao/desfecho/etapaCor já gravados. Todos os callers atuais
// (drag, Ganho, Perdido) continuam passando o conjunto completo, então isso é
// hardening para futuros callers parciais, sem mudança de comportamento hoje.
const patchStatusClienteEmSlice = (slice, patch) => {
  if (!slice || !Array.isArray(slice.data)) return
  const { codigoCliente, idClienteApp } = patch
  const index = slice.data.findIndex((item) => {
    if (codigoCliente) {
      return String(item.codigo_cliente) === String(codigoCliente)
    }
    if (idClienteApp) {
      return Number(item.id_cliente_app) === Number(idClienteApp)
    }
    return false
  })
  if (index === -1) return
  const campos = {}
  Object.keys(CAMPO_PATCH_MAP).forEach((key) => {
    if (patch[key] !== undefined) campos[CAMPO_PATCH_MAP[key]] = patch[key]
  })
  // Substitui o objeto no array (não muta in-place) — garante reatividade
  // Vue 2 mesmo quando o item nunca teve etapa_nome/etapa_cor antes.
  slice.data.splice(index, 1, { ...slice.data[index], ...campos })
}

export const PATCH_STATUS_CLIENTE = (state, payload = {}) => {
  const codigoCliente = payload.codigoCliente || null
  const idClienteApp = payload.idClienteApp || null
  if (!codigoCliente && !idClienteApp) return
  // NÃO usar defaults `= null` na desestruturação do payload: isso apagaria a
  // distinção entre "chave ausente" (preservar valor atual) e "chave enviada
  // como null" (limpar o valor) antes mesmo de chegar em patchStatusClienteEmSlice.
  const patch = {
    codigoCliente,
    idClienteApp,
    etapaNome: payload.etapaNome,
    etapaCor: payload.etapaCor,
    desfecho: payload.desfecho,
    statusMigracao: payload.statusMigracao,
  }
  patchStatusClienteEmSlice(state.clientesProfissional, patch)
  patchStatusClienteEmSlice(state.clientesEscritorio, patch)
}

// --- Cliente ativo do módulo, Simulação e Ensaio (persiste só o código em localStorage) ---
export const SET_CLIENTE_ATIVO = (
  state,
  { codigo = null, nome = '', detalhe = null } = {}
) => {
  state.clienteAtivo = { codigo, nome, detalhe }
  salvarCodigoClienteAtivo(codigo)
}
export const CLEAR_CLIENTE_ATIVO = (state) => {
  state.clienteAtivo = { codigo: null, nome: '', detalhe: null }
  salvarCodigoClienteAtivo(null)
}
